import React, { Component } from "react";
import { Button } from 'primereact/button';
import { Dialog } from 'primereact/dialog';
import * as util from './commons';
import { Col, Form, Row } from 'react-bootstrap';

export default class ShowError extends Component {
    constructor(props) {
        super(props);        
        this.state = {
        }
    }
    thisDialogFooter = () => {
        return (
            <>
            <Row className="justify-content-md-center" style={{ direction: "ltr", textAlign:"right" }}>
                <Col style={{textAlign:"center"}}>
                    <Button label="تائید" icon="pi pi-check" onClick={()=>this.props.closeError()} iconPos="right" severity="danger" />
                </Col>                                       
            </Row>
            </>
        )
    }
    render(){        
        var textAlign = "right";
        return(
            <Dialog visible={this.props.visible} style={{ width: '45rem' }} breakpoints={{ '960px': '75vw', '641px': '90vw' }}
            modal className="p-fluid" footer={() => this.thisDialogFooter()} onHide={this.props.closeError} header={"خطا" + " !!!"}
            >
                <table style={{marginTop:"10px", width:"100%"}}>
                    <tbody>
                    <tr>
                        <td style={{width:"100px", textAlign:"center"}}>
                            <img src={require("./../../src/lib/images/error-icon.png")} alt={"خطا مشاهده گردید"} width="96" height="96" />
                        </td>
                        <td style={{padding:"5px", textAlign:textAlign, verticalAlign:"middle"}}>
                          {
                            this.props.message?
                            <>
                            {this.props.message.split("\n").map((line, index) => (
                                <React.Fragment key={index}>
                                {line}
                                <br />
                                </React.Fragment>
                                ))}                            
                            </>
                            :<></>
                          }  
                        </td>
                    </tr>
                    </tbody>
                </table>

            </Dialog>

        );
    }
}
        